export default "__VITE_ASSET__DIUwMbre__"